/* eslint-disable */
/**
 * 出处：https://www.cnblogs.com/lvyueyang/p/9847813.html
 * 部分地方作了修改
 * @param refs 需要打印refs对象 例如：this.$refs['bba_print_ref']
 * @param cb 回调函数
 */
// this.$nextTick(function () {
//  // DOM 现在更新了
//  // `this` 绑定到当前实例
//  this.doSomethingElse()
// })
// vm.$nextTick( [callback] ) --> https://cn.vuejs.org/v2/api/#vm-nextTick
// 使用时请尽量在nickTick中调用此方法
//打印
export default (refs, cb) => {
  debugger
  let cloneN
  if (Array.isArray(refs)) {
    cloneN = refs[0].cloneNode(true)
  } else {
    cloneN = refs.cloneNode(true)
  }
  const body = document.getElementsByTagName('body')[0]
  cloneN.style.position = 'absolute'
  cloneN.style.zIndex = '9999999999'
  cloneN.style.top = 0
  cloneN.style.left = 0
  cloneN.style.width = '100%'
  cloneN.style.minHeight = '100%'
  cloneN.style.background = '#fff'
  body.appendChild(cloneN)

  // 配置样式
  const bt = body.style.cssText
  body.style.overflowY = 'auto'
  body.style.cloneN = 'auto'
  const eld = document.querySelector('#app')
  const dc = eld.style.cssText
  eld.style.display = 'none'

  window.print()
  // 回调
  if (cb) {
    cb(body.style, bt, eld.style, dc, body, cloneN)
  }
}
